import { Typography } from '@mui/material';
import styled from 'styled-components';

export const ShortDescription = styled(Typography)`
  font-weight: bold;
`;
